import "./App.css"
import './App.css';
import Introduction from "./Components/Introduction/Introduction";
// import ParticleBaground from "./Components/ParticleBaground";
import Navbar from './Navbar/Navbar';
import Skill from "./Components/Skill";
import GithubCalender from "./GitHub/GithubCalender";
import Contact from "./Components/Contact";
import Projects from "./Components/ProjectSec/ProjectSection";
import { SocialMedia } from "./Components/SocialMedia";
function App() {
  return (
    <div className="App">
      {/* <ParticleBaground /> */}
      <Navbar />
      <Introduction />
      <Skill />
      <Projects />
      <GithubCalender />
      <Contact />
      <SocialMedia />
    </div>
  );
}

export default App;
